export const SET_ME = 'me/SET_ME'
export const LOGOUT_ME = 'me/LOGOUT_ME'
export const SET_CONTEXT = 'me/SET_CONTEXT'
